import { InputBase } from "components/Atoms/formInputs/InputBase";
import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import { blurAndSubmitOnEnter } from "utilities/reactUtils";

const FreefieldTextSingleLine = (props: FreefieldInputProps) => {
  const [text, setText] = React.useState(props.initialValue ?? "");

  return <InputBase
    value={text}
    onChange={value => { setText(value); }}
    onBlur={() => { props.onChange(text); }}
    maxLength={serverReference.constants.freeField.maxSingleLineTextLength}
    onKeyDown={blurAndSubmitOnEnter}
    name={props.reference}
  />;
};

export default FreefieldTextSingleLine;